import script from "./Mobile.vue?vue&type=script&setup=true&lang=js"
export * from "./Mobile.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QResponsive from 'quasar/src/components/responsive/QResponsive.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QResponsive,QCarousel,QCarouselSlide,QImg});
